import { Box } from "@mui/material";

const FilterItem = ({
    children,
    minWidth = 180,
    grow = true,
    fullWidthMobile = true,
}) => {
    return (
        <Box
            sx={(theme) => ({
                minWidth: { xs: 0, sm: minWidth },
                flex: grow ? "1 1 180px" : "0 0 auto",

                display: "flex",
                alignItems: "center",

                width: fullWidthMobile ? "100%" : "auto",
                "& > .MuiFormControl-root, & > .MuiAutocomplete-root": {
                    width: "100%",
                    minWidth: 0,
                },

                [theme.breakpoints.up("sm")]: {
                    width: "auto",
                },
                [theme.breakpoints.down("sm")]: {
                    flexBasis: "100%",
                },
            })}
        >
            {children}
        </Box>
    );
};

export default FilterItem;
